module.exports = __webpack_public_path__ + "static/media/AGalaxyofWhales.4af7f44c.jpg";